"use client";

// Overview tab for the admin-user registry detail modal.
// Split out of AdminUserDetailTabComponents.tsx (module-size).

import { Badge } from "@west-tennessee-consulting/ui";
import {
  resolveUserRole,
  getRoleDisplayName,
  getRoleDescription,
} from "@/lib/constants/user-types";
import {
  formatCentralDate,
  userDisplayName,
} from "@/components/admin/users/UserDetailModal/user-detail-utils";
import { Field, type AdminUserTabProps } from "./AdminUserFields";

export function AdminUserOverviewDisplay({ item: user }: AdminUserTabProps) {
  const role = resolveUserRole(user);
  const aliases = (user.email_aliases ?? []).filter(Boolean);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <Field label="Name">{userDisplayName(user)}</Field>
      <Field label="Email">{user.email || "—"}</Field>

      {aliases.length > 0 && (
        <div className="sm:col-span-2">
          <Field label="Email aliases">
            <span className="flex flex-wrap gap-1">
              {aliases.map((alias) => (
                <Badge key={alias} variant="secondary">
                  {alias}
                </Badge>
              ))}
            </span>
          </Field>
        </div>
      )}

      <Field label="Role">{role ? getRoleDisplayName(role) : "—"}</Field>
      <Field label="Status">{user.is_active !== false ? "Active" : "Inactive"}</Field>

      {role && (
        <div className="sm:col-span-2">
          <Field label="Role description">{getRoleDescription(role)}</Field>
        </div>
      )}

      {typeof user.is_billable === "boolean" && (
        <Field label="Billable">{user.is_billable ? "Yes" : "No"}</Field>
      )}
      {typeof user.available_hours === "number" && (
        <Field label="Available hours / week">{user.available_hours}</Field>
      )}

      <Field label="Created">{formatCentralDate(user.created_at)}</Field>
      <Field label="Last updated">{formatCentralDate(user.updated_at)}</Field>
    </div>
  );
}
